import { Injectable, signal, WritableSignal } from '@angular/core';

export type PopupSize =
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | '2xl'
  | '3xl'
  | '4xl'
  | '5xl'
  | '6xl'
  | '7xl'
  | 'fullscreen';

export interface PopupState {
  id: string;
  title: string;
  zIndex: number;
  size?: PopupSize;
}

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  private _popups: WritableSignal<PopupState[]> = signal([]);
  public readonly popups = this._popups.asReadonly();
  private _baseZIndex = 1000;

  open(id: string, title: string, size?: PopupSize): void {
    if (this._popups().some((p) => p.id === id)) {
      return; // Prevent opening the same popup multiple times
    }

    const newPopup: PopupState = {
      id,
      title,
      size: size ?? 'lg',
      zIndex: this._baseZIndex + this._popups().length,
    };
    this._popups.update((popups) => [...popups, newPopup]);
  }

  close(id: string): void {
    this._popups.update((popups) => popups.filter((p) => p.id !== id));
  }
}
